export default "__VITE_ASSET__CL2Jq5Ky__";